export default "__VITE_ASSET__CF8lXq9___"